import { render } from "./CompanyRegisterPage.vue?vue&type=template&id=40f4f663&scoped=true"
import script from "./CompanyRegisterPage.vue?vue&type=script&lang=js"
export * from "./CompanyRegisterPage.vue?vue&type=script&lang=js"

import "./CompanyRegisterPage.vue?vue&type=style&index=0&id=40f4f663&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f4f663"]])

export default __exports__